var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthCheckInBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9932 3.16368C6.7619 -1.41181 0.110422 2.60835 0.00135253 8.05832C-0.0264422 9.44726 0.374496 10.8002 1.17258 12.0475H6.34549L7.26558 10.514C7.53275 10.0687 8.17929 10.0544 8.4616 10.4983L10.4029 13.5488L13.2326 7.57499C13.4794 7.05373 14.2149 7.03718 14.4871 7.54264L16.9128 12.0475H22.8138C27.1851 5.21552 18.5459 -2.56752 11.9932 3.16368Z",
    fill: "#41ABC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8742 13.0839L13.9086 9.43348L11.129 15.3013C10.8926 15.8005 10.1971 15.8439 9.9005 15.3778L7.88643 12.2129L7.3468 13.1123C7.21973 13.324 6.99091 13.4536 6.74394 13.4536H2.28516C2.42493 13.5999 1.68 12.8565 11.4976 22.6232C11.7718 22.8961 12.2151 22.8961 12.4893 22.6232C22.1559 13.0067 21.5623 13.5996 21.7018 13.4536H16.4932C16.2345 13.4536 15.9968 13.3116 15.8742 13.0839Z",
    fill: "#41ABC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCheckInBlue);
export default __webpack_public_path__ + "static/media/health-check-in-blue.0e376226ad534ddb6bf372e0f4f490ef.svg";
export { ForwardRef as ReactComponent };